import { render } from "./ErrorModal.component.vue?vue&type=template&id=81cde9d4&scoped=true&ts=true"
import script from "./ErrorModal.component.vue?vue&type=script&lang=ts"
export * from "./ErrorModal.component.vue?vue&type=script&lang=ts"

import "./ErrorModal.component.vue?vue&type=style&index=0&id=81cde9d4&lang=scss&scoped=true"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81cde9d4"]])

export default __exports__